
import styled from 'styled-components';


/*

Props:

• defaultStyles

• break1_maxWidth
• styles_break1 

• break2_maxWidth
• styles_break2

• break3_maxWidth
• styles_break3

*/

export const StyledMediaQ = styled.div`

    ${props => (props.defaultStyles) ? props.defaultStyles : ''}

    @media (max-width: ${props => (props.break1_maxWidth) ? props.break1_maxWidth : '0'}px){
        ${props => (props.styles_break1) ? props.styles_break1 : ''}
    } 
    @media (max-width: ${props => (props.break2_maxWidth) ? props.break2_maxWidth : '0'}px){
    ${props => (props.styles_break2) ? props.styles_break2 : ''}
    }
    @media (max-width: ${props => (props.break3_maxWidth) ? props.break3_maxWidth : '0'}px){
    ${props => (props.styles_break3) ? props.styles_break3 : ''}
`;



// WEBPACK FOOTER //
// ./src/js/components/StyledMediaQ.jsx